import { Editor } from '@tiptap/core'
import { ButtonProps } from '../config/menu'
import MenuColorPickerButton from './MenuColorPickerButton'
import { useLinkContext } from '../hooks/useLinkContext'
import MenuButtonBase from './MenuButtonBase'

const MenuButton = (props: Omit<ButtonProps, "type"> & { editor: Editor }) => {

    const linkContext = useLinkContext()

    if (props.extraUi?.color) {
        return <MenuColorPickerButton {...props} />
    }

    const onClick = (props.id === 'link') ? linkContext.openModal : props.onClick

    const className = !props.editor ? ''
        : props.className ? props.className(props.editor) : cssActive(props.editor, props.id)

    return (
        <MenuButtonBase id={props.id}
            onClick={() => { onClick(props.editor) }}
            title={props.name}
            className={`${className}`}>
            <props.Icon />
        </MenuButtonBase>
    )

}

const cssActive = (editor: Editor, custom: string) => {
    return editor.isActive(custom) ? 'is-active' : ''
}


export default MenuButton; 